<template>
  <div class="row justify-center " style="min-width: 800px;min-height: 95vh">
    <div class="card q-pa-md">

      <h4 class="mt-0 mb-3 text-left" style="font-size: 26px; font-weight: 300">
        Create partner
      </h4>
      <q-form ref="form">
        <div class="row q-col-gutter-sm">
          <div class="col-6" v-if="loggedIn_partnerType == Constants.RD || loggedIn_partnerType == Constants.VAD">
            <q-select :options="partnerTypesArr"
                      :rules="[val=>val && val.length>0 || 'Please select partnerType']"
                      class="searchBox p-2 my-3"
                      emit-value label="Partner Type*" lazy-rules
                      map-options option-label="name" option-value="id"
                      outlined v-model="form.partnerType">
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    No results
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
          <div class="col-12 text-left section-title">Organization Detail</div>
          <div class="col-12">
            <q-input :rules="[val=>val && val.length>0 || 'Please enter name']" class="searchBox p-2 my-3"
                     label="Company Name*"
                     lazy-rules v-model="form.name"></q-input>
          </div>
          <div class="col-6">
            <q-input :rules="[val=>val && val.length>0 || 'Please enter Aadhaar number',
                                          val=>val && val.replace(/ /g,'').length===12 || 'Please enter a valid Aadhaar number']"
                     class="searchBox p-2 my-3" label="Aadhaar*"
                     lazy-rules
                     mask="#### #### ####"
                     v-if="form.partnerType === Constants.RP" v-model="form.aadhaarNumber"></q-input>
            <q-input class="searchBox p-2 my-3" label="GSTIN"
                     :rules="[v => !v || Constants.GstPattern.test(v) ||'Invalid GSTIN']"
                     lazy-rules mask="XXXXXXXXXXXXXXX"
                     v-else v-model="form.gstin"></q-input>
            <!--mask="##AAAAA####AX"-->
          </div>
          <div class="col-6">
            <q-input class="searchBox p-2 my-3" label="PAN" mask="XXXXXXXXXX" v-model="form.PAN"
                     :rules="[v => !v || Constants.PanPattern.test(v) ||'Invalid PAN']"></q-input>
            <!--mask="AAAAA####A"-->
          </div>
          <div class="col-12">
            <q-input :rules="[val=>val && val.length>0 || 'Please enter address']"
                     class="searchBox p-2 my-3" label="Address Line 1*"
                     lazy-rules v-model="form.address.add1"></q-input>
          </div>
          <div class="col-12">
            <q-input class="searchBox p-2 my-3" label="Address Line 2"
                     v-model="form.address.add2"></q-input>
          </div>
          <div class="col-6">
            <q-select :options="pinArr" @blur="onPopupHide" @filter="searchPincode"
                      @input="autoFillAddressFromPin" class="searchBox p-2 my-3" clearable fill-input
                      label="Search by Pincode*" outlined
                      use-input v-model="form.address.pin">
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    No results
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:option="scope">
                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                  <q-item-section>
                    <q-item-label>
                      {{ scope.opt.Area }}, {{ scope.opt.PinCode }}, {{ scope.opt.DistrictName }},
                      {{ scope.opt.StateName }}
                    </q-item-label>
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:selected-item="scope">
                {{ scope.opt.PinCode }}
              </template>
            </q-select>
            <!--                        <q-input :rules="[val=>val && val.length>0 || 'Please enter Pincode']" label="Pincode"-->
            <!--                                 lazy-rules v-model="form.address.pin"></q-input>-->
          </div>
          <div class="col-6">
            <q-input :rules="[val=>val && val.length>0 || 'Please enter Area']" class="searchBox p-2 my-3"
                     label="Area*"
                     lazy-rules v-model="form.address.area"></q-input>
          </div>
          <div class="col-6">
            <q-input :rules="[val=>val && val.length>0 || 'Please enter City']" class="searchBox p-2 my-3"
                     label="City*"
                     lazy-rules v-model="form.address.city"></q-input>
          </div>
          <div class="col-6">
            <q-input :rules="[val=>val && val.length>0 || 'Please enter State']" class="searchBox p-2 my-3"
                     label="State*"
                     lazy-rules v-model="form.address.state"></q-input>
          </div>
          <div class="col-6">
            <q-input :rules="[val=>val && val.length>0 || 'Please enter Country']"
                     class="searchBox p-2 my-3" label="Country*"
                     lazy-rules v-model="form.address.country"></q-input>
          </div>
          <div class="col-6">
            <!--                        <q-input :max="todayDate" label="Company Incorporate Date" lazy-rules onkeydown="return false"-->
            <!--                                 type="date" v-model="form.incorporateDate"></q-input>-->
            <q-input class="searchBox p-2 my-3" filled label="Company Incorporate Date" mask="##/##/####"
                     v-model="incorporateDate">
              <template v-slot:append>
                <q-icon class="cursor-pointer" name="event">
                  <q-popup-proxy ref="incorporateDate" transition-hide="scale"
                                 transition-show="scale">
                    <q-date @input="() => $refs.incorporateDate.hide()"
                            v-model="form.incorporateDate"/>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
          <!--                    <div class="col-12 text-left section-title">User Detail</div>-->
          <div class="col-6">
            <q-input :rules="[val=>val && val.length>0 || 'Please enter Owner Name']"
                     class="searchBox p-2 my-3" label="Owner Name*"
                     lazy-rules v-model="form.userName"></q-input>
          </div>
          <div class="col-6">
            <q-input :rules="[val=>val && val.length>0 || 'Please enter primary mobile',
                                      val => val.length && val.length === 10 || 'Invalid mobile']"
                     class="searchBox p-2 my-3"
                     label="Primary Mobile*"
                     lazy-rules mask="##########" v-model="form.mobile"></q-input>
          </div>
          <div class="col-6">
            <q-input class="searchBox p-2 my-3" label="Alternate Number"
                     lazy-rules mask="##########" v-model="form.alternateNumber"></q-input>
          </div>

          <div class="col-6">
            <!--                        <q-input :max="todayDate" label="Partner Birthdate" lazy-rules onkeydown="return false" type="date"-->
            <!--                                 v-model="form.userBirthdate"></q-input>-->
            <q-input :rules="[val=>val && val.length>0 || 'Please enter Email',
                                      val => val.length && emailPattern.test(val) || 'Invalid Email']"
                     class="searchBox p-2 my-3" label="Email*"
                     lazy-rules type="email" v-model="form.email"></q-input>

          </div>

          <div class="col-6">
            <q-input class="searchBox p-2 my-3" filled label="Partner Birthdate" mask="##/##/####"
                     v-model="userBirthdate">
              <template v-slot:append>
                <q-icon class="cursor-pointer" name="event">
                  <q-popup-proxy ref="userBirthdate" transition-hide="scale" transition-show="scale">
                    <q-date @input="() => $refs.userBirthdate.hide()" v-model="form.userBirthdate"/>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>

          <div class="col-6">
            <!--                        <q-input :max="todayDate" label="Partner Anniversary" lazy-rules onkeydown="return false"-->
            <!--                                 type="date"-->
            <!--                                 v-model="form.userAniversary"></q-input>-->
            <q-input class="searchBox p-2 my-3" filled label="Partner Anniversary" mask="##/##/####"
                     v-model="userAniversary">
              <template v-slot:append>
                <q-icon class="cursor-pointer" name="event">
                  <q-popup-proxy ref="userAniversary" transition-hide="scale" transition-show="scale">
                    <q-date @input="() => $refs.userAniversary.hide()"
                            v-model="form.userAniversary"/>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>


          <div class="col-12 q-mt-md">
            <div class="row">
              <span class="section-title">Bank Details</span>
              <!--                            <q-space></q-space>-->
              <!--                            <q-btn @click="addBank" color="primary" flat icon="add" round size="12px">-->
              <!--                                <q-tooltip>Add Bank</q-tooltip>-->
              <!--                            </q-btn>-->
            </div>
          </div>
          <template v-for="(bank,bankIndex) in form.bankDetails">
            <!--                        <q-card bordered class="bank-card" flat>-->
            <!--                            <q-card-section>-->
            <div class="row card-close-icon" v-if="bankIndex !== 0">
              <q-space></q-space>
              <q-btn @click="removeBank(bankIndex)" color="red" flat icon="close" round
                     size="8px"></q-btn>
            </div>
            <div class="row q-col-gutter-sm" style="margin-bottom: 70px;">
              <div class="col-4">
                <q-input @input="onTypeIfscCode(bankIndex)" class="searchBox p-2 my-3" debounce="500"
                         label="IFSC"
                         lazy-rules mask="XXXXXXXXXXX"
                         v-model="form.bankDetails[bankIndex].ifsc"></q-input>
              </div>
              <div class="col-8">
                <q-input class="searchBox p-2 my-3" label="Bank Name"
                         v-model="form.bankDetails[bankIndex].bankName"></q-input>
              </div>
              <div class="col-6">
                <q-input class="searchBox p-2 my-3" label="Branch" lazy-rules readonly
                         v-model="form.bankDetails[bankIndex].branch"></q-input>
              </div>
              <div class="col-6">
                <q-input class="searchBox p-2 my-3" label="City" lazy-rules readonly
                         v-model="form.bankDetails[bankIndex].city"></q-input>
              </div>
              <div class="col-6">
                <q-input class="searchBox p-2 my-3" label="Account Name" lazy-rules
                         v-model="form.bankDetails[bankIndex].accountName"></q-input>
              </div>
              <div class="col-6">
                <q-input class="searchBox p-2 my-3" label="Account Number" lazy-rules
                         mask="##################"
                         v-model="form.bankDetails[bankIndex].accountNumber"></q-input>
              </div>
              <div class="col-6">
                <q-select :options="accountTypeArr" class="searchBox p-2 my-3" label="Account Type"
                          lazy-rules
                          v-model="form.bankDetails[bankIndex].acountType"></q-select>
              </div>
              <template v-if="loggedIn_partnerType == Constants.RD||loggedIn_partnerType == Constants.VAD">
                <div class="col-12 q-mt-md">
                  <div class="row">
                    <span class="section-title">Reference</span>
                  </div>
                </div>

                <div class="col-12">
                  <!--                        :rules="[val=>val && typeof(val)=='object' || 'Please select Organization']"-->
                  <q-select :hint="form.partnerType === Constants.RP?'*Cannot change for Retail Partner (RP)':''"
                            :options="organizationArr" :readonly="form.partnerType === Constants.RP"
                            :rules="[val=>val && typeof(val) === 'object' || 'Please select Referral VAP']"
                            @filter="searchOrganization" class="searchBox p-2 mb-3" clearable
                            label="Select Referral VAP" outlined use-input v-model="form.orgObj">
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-grey">
                          No results
                        </q-item-section>
                      </q-item>
                    </template>
                    <template v-slot:option="scope">
                      <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                        <q-item-section>
                          <q-item-label v-html="scope.opt.name"></q-item-label>
                          <q-item-label caption>{{ scope.opt.mobile }}</q-item-label>
                        </q-item-section>
                        <q-item-section>
                          <q-item-label>{{ scope.opt.partnerCode }}</q-item-label>
                        </q-item-section>
                      </q-item>
                    </template>
                    <template v-slot:selected-item="scope">
                      {{ scope.opt.name }}
                    </template>
                  </q-select>
                </div>
              </template>
            </div>
            <!--                            </q-card-section>-->
            <!--                        </q-card>-->
          </template>

          <div class="col-12 w-100">
            <div class="position-relative w-100" style="margin-left: -16px;">
              <div class="app-fixed-footer w-100" style="padding-left: 14px; bottom: 20px;">
                <div class="d-flex " style="justify-content: left">
                  <q-btn @click="handleSubmit('form')" class="pd-btn  my-3">Register Partner
                  </q-btn>
                  <!--<q-btn @click="handleSubmit('form')" class="pd-btn p-2 my-3">Register Partner</q-btn>-->
                  <q-btn @click="closeDialog" class=" my-3 ml-3" color="primary">CANCEL</q-btn>
                </div>
              </div>
            </div>
          </div>
          <!--<div class="col-12 q-pt-md">-->
          <!--<div class="d-flex " style="justify-content: left">-->
          <!--<q-btn class="pd-btn" @click="handleSubmit('form')" >Register Partner</q-btn>-->
          <!--</div>-->
          <!--</div>-->
          <!--<div class="col-12 q-pt-md">-->
          <!--<q-btn @click="handleSubmit('form')" color="primary">Register Partner</q-btn>-->
          <!--</div>-->
        </div>
      </q-form>
    </div>
  </div>
</template>

<script>
import { GET_PARTNER_TYPE } from '../graphql/queries/application'
import { INSERT_APPLICATIONS } from '../graphql/mutations/application'
import { SEARCH_ORGANIZATION } from '../graphql/queries/organization'
import { SEARCH_PINCODE } from '../graphql/queries/territories'
import { NetworkCommunicator } from '../plugins/NetworkResourceHandler'
import Constants from '../Constants/Constant'
import moment from 'moment'
import { CHECK_DUPLICATE_APPLICATION_DETAILS } from '@/graphql/queries/application'

export default {
  apollo: {
    Territories: {
      query: SEARCH_PINCODE,
      fetchPolicy: 'network-only',
      skip: true,
      variables () {
        return {
          pinFilter: this.pinFilter ? this.pinFilter : '0',
        }
      },
      result ({ data, loading }) {
        if (!loading) {
          this.pinArr = data.Territories
          this.temp_pinArr = JSON.parse(JSON.stringify(data.Territories))
        }
      },
    },
    Organizations: {
      query: SEARCH_ORGANIZATION,
      fetchPolicy: 'network-only',
      variables () {
        return {
          orgFilter: this.orgFilter,
        }
      },
      // debounce: 500,
      // skip: true,
      result ({ data, loading }) {
        if (!loading) {
          this.organizationArr = data.Organizations
        }
      },
    },
  },
  name: 'CreatePartner',
  data () {
    let self = this
    return {
      Constants: Constants,
      moment: moment,
      todayDate: moment().format('YYYY-MM-DD'),
      userObj: JSON.parse(localStorage.getItem('user')),
      loggedIn_partnerType: JSON.parse(localStorage.getItem('user')).organization.partnerType,
      emailPattern: new RegExp(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
      form: {
        id: self.generateUUID(),
        partnerType: '',
        stageId: 'e31246ae-9b12-457d-9145-ec45cb6a341e',
        name: '', userName: '',
        address: {
          add1: '', add2: '', pin: '', area: '',
          city: '', state: '', country: '',
        }, email: '',
        mobile: '', alternateNumber: '',
        incorporateDate: null,
        userBirthdate: null,
        userAniversary: null,
        gstin: null, PAN: null, aadhaarNumber: '',
        // password: 'AA7F713AAF8159DA1DB7066272926DC3',
        orgObj: { id: '60bb56a3-bea4-4edd-906c-d1879ce12ea1', name: 'AIPL', partnerCode: 'NP963545' },
        bankDetails: [
          {
            accountName: '', accountNumber: '', bankName: '',
            ifsc: '', branch: '', city: '', acountType: '',
          }],
      },
      organizationArr: [],
      partnerTypesArr: [],
      pinArr: [],
      temp_pinArr: [],
      accountTypeArr: ['Saving', 'Current'],
      loadingState: false,
      orgFilter: '%%',
      pinFilter: '%%',
      tempValue: null,
    }
  },
  watch: {
    'form.partnerType' (val) {
      if (val === Constants.RP) {
        this.form.orgObj = { id: '60bb56a3-bea4-4edd-906c-d1879ce12ea1', name: 'AIPL', partnerCode: 'NP963545' }
      }
    },
  },
  mounted () {
    this.getPartnerType()
  },
  computed: {
    userBirthdate: {
      // getter
      get: function () {
        return moment(this.form.userBirthdate).format('DD/MM/YYYY')
      },
      // setter
      set: function (newValue) {
        if (!newValue) {
          this.form.userBirthdate = null
        }
      },
    },
    userAniversary: {
      // getter
      get: function () {
        return moment(this.form.userAniversary).format('DD/MM/YYYY')
      },
      // setter
      set: function (newValue) {
        if (!newValue) {
          this.form.userAniversary = null
        }
      },
    },
    incorporateDate: {
      // getter
      get: function () {
        return moment(this.form.incorporateDate).format('DD/MM/YYYY')
      },
      // setter
      set: function (newValue) {
        if (!newValue) {
          this.form.incorporateDate = null
        }
      },
    },
  },
  methods: {
    autoFillAddressFromPin () {
      if (this.form.address.pin) {
        this.form.address.area = this.form.address.pin.Area
        this.form.address.city = this.form.address.pin.DistrictName
        this.form.address.state = this.form.address.pin.StateName
        this.form.address.country = this.form.address.pin.CountryName
        this.form.address.pin = this.form.address.pin.PinCode
      } else {
        this.form.address.pin = ''
        this.form.address.area = ''
        this.form.address.city = ''
        this.form.address.state = ''
        this.form.address.country = ''
      }
    },
    onPopupHide (val) {
      if (this.tempValue && this.tempValue.length == 6) {
        this.pinArr = [{ PinCode: this.tempValue }]
        this.form.address.pin = this.tempValue
      }
      this.tempValue = null
    },
    searchPincode (val, update, abort) {
      this.tempValue = val
      this.pinArr = JSON.parse(JSON.stringify(this.temp_pinArr))
      if (val.length < 5) {
        abort()
        return
      }
      update(() => {
        this.pinFilter = '%' + val + '%'
        this.$apollo.queries.Territories.skip = false
      })
    },
    searchOrganization (val, update, abort) {
      if (val.length < 1) {
        abort()
        return
      }
      update(() => {
        this.orgFilter = '%' + val + '%'
      })
    },
    handleSubmit (name) {
      this.$refs[name].validate().then((success) => {
        if (success) {
          this.checkApplicationDuplication()
        } else {
          this.$q.notify('Please review the form errors highlighted in red')
        }
      })
    },
    async checkApplicationDuplication () {
      // DO NOT MODIFY THIS CODE
      // IF YOU DO NOT KNOW ABOUT THIS
      // OR WITHOUT CONSULTATION
      let response = await this.$apollo.query({
        query: CHECK_DUPLICATE_APPLICATION_DETAILS,
        variables: {
          id: 'f2793954-7b3e-47d4-aff1-0091f2dd8057',
          mobile: this.form.mobile ? this.form.mobile : 'f2793954-7b3e-47d4-aff1-0091f2dd8057',
          gstin: this.form.gstin ? this.form.gstin : 'f2793954-7b3e-47d4-aff1-0091f2dd8057',
          PAN: this.form.PAN ? this.form.PAN : 'f2793954-7b3e-47d4-aff1-0091f2dd8057',
          aadhaarNumber: this.form.aadhaarNumber ? this.form.aadhaarNumber : 'f2793954-7b3e-47d4-aff1-0091f2dd8057',
        },
      })
      if (response.data.Applications.length) {
        this.$q.notify('Application note created, details are duplicated.')
      } else {
        this.insertApplication()
      }
    },
    async insertApplication () {
      let self = this
      for (var key in this.form.address) {
        this.form.address[key] = this.form.address[key].toSentenceCase()
      }
      for (var key in this.form.bankDetails[0]) {
        if (key !== 'ifsc') this.form.bankDetails[0][key] = this.form.bankDetails[0][key].toSentenceCase()
      }
      self.$apollo.mutate({
        mutation: INSERT_APPLICATIONS,
        variables: {
          id: self.generateUUID(),
          userId: JSON.parse(localStorage.getItem('user')).id,
          partnerType: (self.loggedIn_partnerType === Constants.RD || self.loggedIn_partnerType === Constants.VAD) ?
              self.form.partnerType : Constants.VAP,   /* Default send VAP PartnerType except RD,VAD logged in */
          stageId: Constants.docPending,
          name: self.form.name.toSentenceCase(),
          userName: self.form.userName.toSentenceCase(),
          address: self.form.address,
          mobile: self.form.mobile.toString(),
          alternateNumber: self.form.alternateNumber ? self.form.alternateNumber.toString() : '',
          email: self.form.email,
          gstin: self.form.partnerType === Constants.RP ? null : self.form.gstin,
          aadhaarNumber: self.form.partnerType === Constants.RP ? self.form.aadhaarNumber.replace(/ /g, '') : null,
          // password: self.form.password,
          PAN: self.form.PAN,
          incorporateDate: self.form.incorporateDate ? moment(self.form.incorporateDate).format('YYYY-MM-DD') : null,
          userBirthdate: self.form.userBirthdate ? moment(self.form.userBirthdate).format('YYYY-MM-DD') : null,
          userAniversary: self.form.userAniversary ? moment(self.form.userAniversary).format('YYYY-MM-DD') : null,
          bankDetails: self.form.bankDetails,
          prefferedDistributors: (self.loggedIn_partnerType === '3260ebcf-8944-4dc1-a003-9997b0e07811' ||
              self.loggedIn_partnerType === '917370fd-9532-4f84-bd30-9b6f0777e206') ? [
                self.userObj.organization.id,
                '60bb56a3-bea4-4edd-906c-d1879ce12ea1']
              : ['60bb56a3-bea4-4edd-906c-d1879ce12ea1'],
          parentPartnerId: (self.loggedIn_partnerType === Constants.RD || self.loggedIn_partnerType === Constants.VAD)
              ? self.form.orgObj.id : self.userObj.organization.id,
          referralCode: (self.loggedIn_partnerType === '3260ebcf-8944-4dc1-a003-9997b0e07811' ||
              self.loggedIn_partnerType === '917370fd-9532-4f84-bd30-9b6f0777e206') ?
              (self.form.orgObj.partnerCode ? self.form.orgObj.partnerCode : '') :
              (self.userObj.organization.partnerCode ? self.userObj.organization.partnerCode : ''),
        },
      }).then(function (response) {
        self.$q.notify('Application Created Successfully')
        setTimeout(function () {
          self.$router.go()
        }, 1000)
      }).catch(function (err) { })
    },
    saveBank (bankIndex) {
      this.getBankDetailsFromIfscCode(this.form.bankDetails[bankIndex].ifsc, bankIndex)
    },
    addBank () {
      this.form.bankDetails.push({ accountName: '', ifsc: '', branch: '', city: '', acountType: '' })
    },
    closeDialog () {
      this.$emit('closeCreatePartnerDialog', false)
    },
    removeBank (index) {
      this.form.bankDetails.splice(index, 1)
    },
    async getPartnerType () {
      let response = await this.$apollo.query({
        query: GET_PARTNER_TYPE,
      })
      this.partnerTypesArr = []
      response.data.PartnerType.forEach((partner, index) => {
        if ((this.loggedIn_partnerType === Constants.RD && partner.prefix !== 'ND' && partner.prefix !== 'RD') ||
            (this.loggedIn_partnerType === Constants.VAD && partner.prefix !== 'ND' && partner.prefix !== 'RD' &&
                partner.prefix !== 'VAD')) {
          this.partnerTypesArr.push(partner)
        }
      })
    },
    onTypeIfscCode (index) {
      if (this.form.bankDetails[index].ifsc.length === 11) {
        this.getBankDetailsFromIfscCode(this.form.bankDetails[index].ifsc, index)
      }
    },
    async getBankDetailsFromIfscCode (ifscCode, bankIndex) {
      let response = await NetworkCommunicator('GET',
          `${Constants.razorpay_url}${ifscCode}`)
      if (response) {
        this.form.bankDetails[bankIndex].branch = response.BRANCH
        this.form.bankDetails[bankIndex].city = response.CITY
        this.form.bankDetails[bankIndex].bankName = response.BANK
      } else {
        this.$q.notify('Bank IFSC Not Found')
      }
    },
    generateUUID () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
  },
}
</script>

<style scoped>
.card {
  text-align: center;
  width: 100%;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: bottom;
  border-radius: 4px;
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
  position: relative;
}

.section-title {
  font-weight: bolder;
  font-size: 16px;
}

.bank-card {
  margin-top: 7px;
}

.card-close-icon {
  margin: -24px -17px 0 0;
}

/deep/ .q-field--outlined .q-field__control {
  padding: 0px !important;
}
</style>
